module.exports = __webpack_public_path__ + "img/header-bg-3.e2368913.png";